module.exports = __webpack_public_path__ + "static/media/loginSplash.f7273160.svg";